// Maps the product language (en/fr/es) to a BCP 47 identifier for
// Date.prototype.toLocaleDateString. English is the default, never pinned to fr-CA.
export const dateLocale = (lang) => ({ fr: "fr-CA", es: "es" }[lang] || "en-CA");
